<template>
  <a-spin :spinning="confirmLoading">
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <!--label="禽苗成本"-->
            <a-form-item :label="$t('label.docCost')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['chickCost', validatorRules.chickCost]" :placeholder="$t('label.pleaseEnterTheDocCost')" style="width: 84%"/> {{ $t('label.rMBBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="饲料成本"-->
            <a-form-item :label="$t('label.feedCost')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedCost', validatorRules.feedCost]" :placeholder="$t('label.pleaseEnterTheFeedCostStandard')" style="width: 84%"/> {{ $t('label.rMBBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="药品成本"-->
            <a-form-item  :label="$t('label.medicineCost')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['drugCost', validatorRules.drugCost]" :placeholder="$t('label.pleaseInputTheCostStandardOfMedicine')" style="width: 84%"/> {{ $t('label.rMBBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'conCode'" :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input  v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="8">-->
<!--            <a-form-item v-has="'buffer3'" label="其他成本 元/只" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input-number v-decorator="['buffer3', {'initialValue': '1'}]" placeholder="请输入其他成本 元/只" style="width: 100%"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
        </a-row>
      </a-form>
    </j-form-container>
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="$t('tabName.priceList')" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsMdContractPriceListDetailTable.loading"
          :columns="efsMdContractPriceListDetailTable.columns"
          :dataSource="efsMdContractPriceListDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="false"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { FormTypes, getRefPromise } from '@/utils/JEditableTableUtil'
  export default {
    name: 'SettlePriceListForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      // 当前table对应的数据表名
      tableName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          chickCost: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheDocCost')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          feedCost: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFeedCostStandard')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          drugCost: {
            rules: [
              { required: true, message: this.$t('label.pleaseInputTheCostStandardOfMedicine')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          // othersCost: {
          //   rules: [
          //     { required: false},
          //     { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
          //   ]
          // },
        },
        refKeys: ['efsMdContractPriceListDetail', ],
        tableKeys:['efsMdContractPriceListDetail', ],
        activeKey: 'efsMdContractPriceListDetail',
        // 合同价格清单详情
        efsMdContractPriceListDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              //title: '物料类别',
              title: this.$t('tableHeader.materialCategory'),
              key: 'categoryCode',
              type: FormTypes.sel_search,
              dictCode:"sys_dict_item,item_text,item_value,dict_id=(select id  from sys_dict where dict_code='mm_category')",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '物料编号',
              title: this.$t('tableHeader.materialNumber'),
              key: 'mmCode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '物料名',
              title: this.$t('tableHeader.materialName'),
              key: 'mmName',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '规格',
              title: this.$t('tableHeader.specification'),
              key: 'spec',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '单位',
              title: this.$t('tableHeader.unit'),
              key: 'unit',
              type: FormTypes.sel_search,
              dictCode:"sys_dict_item,item_text,item_value,dict_id=(select id from sys_dict where dict_code='material_unit_type')",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              //title: '单价',
              title: this.$t('tableHeader.unitPrice'),
              key: 'price',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
              {
                  //title: '生效日期',
                  title: this.$t('tableHeader.effectiveDate'),
                  key: 'effectiveDate',
                  type: FormTypes.inputNumber,
                  width:"200px",
                  disabled:true,
                  placeholder: this.$t('tip.pleaseInput') +'${title}',
                  defaultValue: '',
              },
              {
                  //title: '版本',
                  title: this.$t('tableHeader.version'),
                  key: 'version',
                  type: FormTypes.inputNumber,
                  width:"50px",
                  disabled:true,
                  placeholder: this.$t('tip.pleaseInput') +'${title}',
                  defaultValue: '',
              },
          ]
        },
        url: {
          efsMdContractPriceListDetail: {
            list: '/newContractManage/efsMdContract/queryEfsMdContractPriceListDetailByChangeMainId'
          },
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("SettlePriceListForm-edit",this.model);
        let fieldval = pick(this.model,'conCode','chickCost','feedCost','drugCost')
        if (this.model.id) {
          let params = { conCode: this.model.conCode }
          this.requestSubTableData(this.url.efsMdContractPriceListDetail.list, params, this.efsMdContractPriceListDetailTable)
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError",this.$t('tip.contractBreakdownSheetFailedTo'));
          }
        })
        console.log("合同明细表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'chickCost','feedCost','drugCost'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
